/* eslint-disable react-hooks/exhaustive-deps */
import {
    ArrowBack,
    CheckCircle,
    DriveFileMoveRounded,
    FileDownloadOutlined,
    FileUploadOutlined,
    PlayCircle,
    Settings,
} from "@mui/icons-material";
import { Box, Button, Card, CardContent, Grid } from "@mui/material";
import { GridRowModel, GridRowSelectionModel, GridSortModel, GridSortDirection } from "@mui/x-data-grid";
import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import DialogInfo from "@/components/informationDialog";
import { Container } from "@/theme/globalStyles";
import DataTable from "../../../components/dataTable";
import { useAuth } from "../../../context/global";
import messages from "@/utils/messages";
import serviceRebateUsinaInstalacao from "@/services/serviceRebateUsinaInstalacao";

const RebateDetalhar: React.FC = (props: any) => {
    const { setTitlePage } = useAuth();
    const history = useHistory();
    const filterOld = props.location.state.filterOld || "";

    useEffect(() => {
        setTitlePage("Detalhar");
    }, [setTitlePage]);

    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [rowCount, setRowCount] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [linesSelecteds, setLinesSelecteds] = useState<GridRowSelectionModel>([]);
    const [dataMessages, setDataMessages] = useState<string[]>([]);
    const [infoModal, setInfoModal] = useState(false);

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "rebateId",
                type: "string",
                headerAlign: "left",
                identity: true,
                width: 70,
            },
            {
                headerName: "Ciclo",
                field: "ciclo",
                type: "string",
                width: 120,
            },
            {
                headerName: "UC",
                field: "uc",
                type: "string",
                width: 120,
            },
            {
                headerName: "Nome",
                field: "nome",
                type: "string",
                width: 320,
            },
            {
                headerName: "Documento",
                field: "documento",
                type: "string",
                width: 150,
            },
            {
                headerName: "Cod Externo",
                field: "codExterno",
                type: "string",
                width: 120,
            },
            {
                headerName: "Usina",
                field: "usina",
                type: "string",
                width: 220,
            },
            {
                headerName: "Cota KWP",
                field: "cotaKWP",
                type: "string",
                width: 120,
            },
            {
                headerName: "Cota KWH",
                field: "cotaKWH",
                type: "string",
                width: 120,
            },
            {
                headerName: "Concessionária",
                field: "concessionaria",
                type: "string",
                width: 320,
            },
            {
                headerName: "Tipo Usina",
                field: "tipoUsina",
                type: "string",
                width: 120,
            },
            {
                headerName: "Desconto Contratado",
                field: "descontroContratado",
                type: "string",
                width: 200,
            },
            {
                headerName: "Desconto Faturamento",
                field: "descontoFaturado",
                type: "string",
                width: 220,
            },
            {
                headerName: "Classe",
                field: "classe",
                type: "string",
                width: 120,
            },
            {
                headerName: "Estado",
                field: "estado",
                type: "string",
                width: 120,
            },
            {
                headerName: "Grupo Concessionária",
                field: "grupoLeitura",
                type: "string",
                width: 190,
            },
            {
                headerName: "ID Parametro Rebate Aplicado",
                field: "parametroRebateID",
                type: "string",
                width: 230,
            },
            {
                headerName: "Tipo Rebate",
                field: "tipoRebate",
                type: "string",
                width: 200,
            },
            {
                headerName: "Tipo de Cálculo",
                field: "tipoCalculo",
                type: "string",
                width: 200,
            },
            {
                headerName: "Tipo Pesquisa Cliente",
                field: "tipoPesquisaCliente",
                type: "string",
                width: 180,
            },
            {
                headerName: "Rebate %",
                field: "percentualRebate",
                type: "string",
                width: 120,
            },
        ],
        []
    );

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        serviceRebateUsinaInstalacao
            .getWithFilter({
                rebateUsinaID: filters.rebateID,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                if (result) {
                    setData(result?.data.content);
                    setRowCount(result?.data.numberOfElements);
                }
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            getAllWithFilters(props.location.state);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    useEffect(() => {
        if (props && props.location && props.location.state) {
            getAllWithFilters(props.location.state);
        }
    }, [props]);

    useEffect(() => {
        if (dataMessages.length > 0) {
            setInfoModal(true);
        }
    }, [dataMessages]);

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <Grid container spacing={2}>
                            <Grid item md={12}>
                                <Grid container spacing={2}>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="text"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<ArrowBack />}
                                            onClick={() => {
                                                const newArray = filterOld.usinasIds
                                                    ? Array.isArray(filterOld.usinasIds)
                                                        ? filterOld.usinasIds
                                                        : filterOld.usinasIds.split(",")
                                                    : "";
                                                history.push("/analisetarifaria/calculorebate", {
                                                    ...filterOld,
                                                    usinasIds: newArray,
                                                });
                                            }}
                                        >
                                            Voltar
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<PlayCircle />}
                                            disabled={true}
                                        >
                                            Iniciar
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<FileDownloadOutlined />}
                                            disabled={true}
                                        >
                                            Download
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<FileUploadOutlined />}
                                            onClick={() => {}}
                                            disabled={true}
                                        >
                                            Importar
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<Settings />}
                                            disabled={true}
                                        >
                                            Processar
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<CheckCircle />}
                                            disabled={true}
                                        >
                                            Aprovar
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<DriveFileMoveRounded />}
                                            disabled={true}
                                        >
                                            Reabrir
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => `${row.id + row.uc}`}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            checkboxSelection
                            onRowSelectionModelChange={(newSelectionModel) => {
                                setLinesSelecteds(newSelectionModel);
                            }}
                            rowSelectionModel={linesSelecteds}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>
                </CardContent>
                {infoModal && (
                    <DialogInfo
                        data={dataMessages}
                        onClose={() => {
                            setInfoModal(false);
                            setDataMessages([]);
                        }}
                    />
                )}
            </Card>
        </Container>
    );
};

export default RebateDetalhar;
